/** @format */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import './footer.less';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div className="footer" />;
  }
}

const mapStateToProps = state => ({
  count: state.pageHeaderReducer.notificationCount,
  username: state.userReducer.username,
  userImage: state.userReducer.userImage,
  userId: state.userReducer.userId,
});

Footer = connect(mapStateToProps)(Footer);

export default Footer;
